module.exports = __webpack_public_path__ + "static/media/szkolenia.f67bef21.jpg";